/* eslint-disable new-cap */

//
// initialEntries is an optimal parameter to be a bit more efficient
//
function StringBuilder (initialEntries) {
    if (initialEntries !== null && parseInt(initialEntries, 10) > 0) {
        this.Contents = new Array(parseInt(initialEntries, 10));
    }
    else {
        this.Contents = [];
    }
    this.CurrentEntry = 0;
}

StringBuilder.prototype = {
    Append: function (str) {
        this.Contents[this.CurrentEntry] = str;
        this.CurrentEntry += 1;
    },

    AppendLine: function (str) {
        this.Append(str + "\r\n");
    },

    toString: function () {
        return this.Contents.join("").trim();
    }
};
